import { render, staticRenderFns } from "./CouponsAddedOverTimeStatistics.vue?vue&type=template&id=523d0e84&"
import script from "./CouponsAddedOverTimeStatistics.vue?vue&type=script&lang=js&"
export * from "./CouponsAddedOverTimeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports